// src/pages/Accounting/JournalEntries/journalEntryTypes.js
// أنواع وحالات القيود — مكان واحد بدل تكرارها في القائمة والنموذج والطباعة

export const ENTRY_TYPES = [
  { value: 1,  key: 'dailyEntry',          label: 'قيد يومية',        manual: true },
  { value: 2,  key: 'openingEntry',        label: 'قيد افتتاحي',      manual: true },
  { value: 3,  key: 'salesEntry',          label: 'قيد مبيعات' },
  { value: 4,  key: 'salesReturnEntry',    label: 'قيد مرتجع مبيعات' },
  { value: 5,  key: 'purchaseEntry',       label: 'قيد مشتريات' },
  { value: 6,  key: 'purchaseReturnEntry', label: 'قيد مرتجع مشتريات' },
  { value: 7,  key: 'paymentVoucher',      label: 'قيد سند صرف' },
  { value: 8,  key: 'receiptVoucher',      label: 'قيد سند قبض' },
  { value: 9,  key: 'transferEntry',       label: 'قيد تحويل' },
  { value: 10, key: 'adjustmentEntry',     label: 'قيد تسوية',        manual: true },
  { value: 11, key: 'depreciationEntry',   label: 'قيد إهلاك' },
  { value: 12, key: 'payrollEntry',        label: 'قيد رواتب' },
  { value: 13, key: 'closingEntry',        label: 'قيد إقفال' },
];

export const ENTRY_STATUS = {
  1: { label: 'مسودة',  bg: '#f1f5f9', fg: '#475569' },
  2: { label: 'مرحّل',  bg: '#d1fae5', fg: '#047857' },
  3: { label: 'ملغي',   bg: '#ffe4e6', fg: '#be123c' },
};

/** يعيد قائمة الأنواع بأسماء مترجمة (مع اسم عربي احتياطي إن لم يوجد مفتاح الترجمة) */
export const getEntryTypes = (t) =>
  ENTRY_TYPES.map(e => ({ ...e, label: t ? t(e.key, { defaultValue: e.label }) : e.label }));

export const entryTypeLabel = (type, t) => {
  const e = ENTRY_TYPES.find(x => x.value === Number(type));
  if (!e) return String(type ?? '');
  return t ? t(e.key, { defaultValue: e.label }) : e.label;
};

/** القيود الآلية لا تُعدّل/تُرحّل/تُحذف يدويًا — تُدار من العملية الأصلية */
export const isSystemEntry = (type) => !ENTRY_TYPES.find(e => e.value === Number(type))?.manual;

/** رسالة خطأ مقروءة من استجابة الـ API */
export const apiError = (err, fallback = 'حدث خطأ غير متوقع') => {
  const d = err?.response?.data;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  if (d.message) return d.message;
  if (d.errors) return Object.values(d.errors).flat().join(' — ');
  return d.title || fallback;
};
